// REL_1.1.14 F-262 / S-982 + S-986 — cross-origin contact form submission.
// Marketing site (www.deedo.ai) → APIM-fronted /api/contact (per A2 reuse web-bundle product).
// Adds `country` payload field per S-986 (DBA 054 adds ContactInquiries.Country VARCHAR(2) NULL).

const API_GATEWAY_URL = import.meta.env.VITE_API_GATEWAY_URL;
const APIM_KEY = import.meta.env.VITE_APIM_KEY ?? "";

export interface ContactRequest {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  inquiryType: string;
  cfTurnstileResponse: string | null;
  country: string; // 'us', forward-compatible for 'uk'/'ca'/'eu' per /us/* page-scope
}

export class RateLimitError extends Error {
  constructor() {
    super("Rate limit exceeded");
    this.name = "RateLimitError";
  }
}

export async function submitContactInquiry(payload: ContactRequest): Promise<void> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (APIM_KEY) headers["Ocp-Apim-Subscription-Key"] = APIM_KEY;

  const body = {
    first_name: payload.firstName,
    last_name: payload.lastName,
    email: payload.email,
    message: payload.message,
    inquiry_type: payload.inquiryType,
    cf_turnstile_response: payload.cfTurnstileResponse,
    country: payload.country,
  };

  const response = await fetch(`${API_GATEWAY_URL}/api/contact`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (response.status === 429) throw new RateLimitError();
  if (!response.ok) {
    throw new Error(`POST /api/contact failed: ${response.status}`);
  }
}
